module.exports = __webpack_public_path__ + "static/img/bg@2x.9781f74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/ZBActivity/bg@2x.png
// module id = WDvC
// module chunks = 69